import { CultureInfo } from '../culture-info.model';
import { CultureInfoSs } from './ss';

/**
 * @ignore
 */
export const CultureInfoSsSZ: CultureInfo = {
  name: 'ss-SZ',
  displayName: 'siSwati (eSwatini)',
  iso3LanguageCode: 'ssw',
  iso2LanguageCode: 'ss',
  ietfLanguageTag: 'ss-SZ',
  parent: CultureInfoSs
};
